import { createRoute } from "@tanstack/react-router";

import { requirePlatformAdmin } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { TestPage } from "./test.page";

export const testRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/admin/test",
	beforeLoad: ({ context }) => requirePlatformAdmin(context.queryClient),
	component: TestPage,
});
